import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { ILocalAdminActions, IThunkActivateLocalAdmin } from '../types';

const onActivateLocalAdmin: IThunkActivateLocalAdmin = thunk(
  async ({ activateLocalAdmin }: Actions<ILocalAdminActions>, payload) => {
    const { clinicId, localAdminId } = payload;

    await api.localAdmin.activateLocalAdmin(clinicId, localAdminId);

    activateLocalAdmin(localAdminId);
  },
);

export default onActivateLocalAdmin;
